export class UserLocationPass {
  id: number | undefined
  user: object | null
  dateCreated: Date | string
  locationPass: object | null
  dateFrom: Date | string
  dateTo: Date | string
  userLocationPassEntryList: object | null

  constructor() {
    this.user = null
    this.dateCreated = ''
    this.locationPass = null
    this.dateFrom = ''
    this.dateTo = ''
    this.userLocationPassEntryList = []
  }
}
